import request from 'utils/request';
import { DictionaryDto } from './dictionary';

export interface EmcTypeDto extends Omit<DictionaryDto, 'status'> {
    is_send_courier: boolean;
}

export const fetchEmcTypes = (): Promise<DictionaryDto[]> => {
    return request
        .get('/mail-type/list', { params: { page: 0, size: 1000, sort: 'id,asc', value: '' } })
        .then(({ data }) => data.content as DictionaryDto[]);
};

export const initEmcType = (): EmcTypeDto => {
    return {
        description: '',
        code: '',
        id: '',
        is_send_courier: true,
    };
};
